module.exports = __webpack_public_path__ + "../resources/img/ic-re-new-page-default.460d4a60.svg";